import React from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'

import { logout } from 'app-support/auth/state/actions'

const enhance = connect(null, { logout })

interface ILogoutProps {
  logout: () => any
}

export class Logout extends React.Component<ILogoutProps> {
  state = {
    isDone: false
  }

  componentDidMount() {
    const { logout } = this.props

    logout()

    this.setState({ isDone: true })
  }

  render() {
    const { isDone } = this.state

    if (!isDone) {
      return null
    }

    return <Redirect to='/' />
  }
}

export default enhance(Logout)
